import styled from 'styled-components';

export const EditionForm = styled.div`
  padding: 2rem;
  max-width: 60rem;
  margin: 0 auto;
  padding-bottom: 12rem;

  .avatar_layer {
    position: relative;
    width: 15rem;
    margin: 0 auto;
    display: block;

    .btn_edit_profile {
      width: 5rem;
      height: 5rem;
      background-color: ${props => props.color};
      border-radius: 50%;
      cursor: pointer;
      text-align: center;
      line-height: 5.5rem;
      position: absolute;
      bottom: 0rem;
      right: 0rem;
      z-index: 5;

      i {
        font-size: 2rem;
        color: #fff;
      }
    }
  }

  .buttons {
    text-align: center;
    margin-top: 2rem;

    button {
      min-width: 12rem;
    }
  }
`;

export const LoadingWrapper = styled.div`
  width: 60rem;
  height: 60rem;
  max-width: 100vw;
  max-height: 100vh;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/routes/ProfileEdit/components/styles.js